import React from 'react'
import { Checkbox, FormGroup, TextField, Typography } from '@mui/material'
import update from 'immutability-helper'
import { initRule } from '../../../lib/rule'
import { formUpdate } from '../../../lib/form'
import AccordionPreset from './AccordionPreset'

const name = 'speed-board'

const initPreset = {
  name,
  rightsPointCorrect: 3,
  otherPointCorrect: 1,
  rightsPointWrong: -1,
  winPoint: {
    active: false,
    value: 15
  },
  winPlayers: 0
}

const SpeedBoard = ({ accordionExpanded, onAccordionChange, rule, setRule }) => {
  const [form, setForm] = React.useState(initPreset)
  const change = formUpdate(setForm)

  React.useEffect(() => {
    setForm((rule.preset && rule.preset.name === name) ? rule.preset : initPreset)
  }, [rule.preset])

  const submit = () => {
    const newRule = update(initRule, {
      player: {
        pointCorrect: { $set: form.rightsPointCorrect - form.otherPointCorrect },
        pointWrong: { $set: form.rightsPointWrong },
        batsuWrong: { $set: 0 },
        winPlayers: { $set: form.winPlayers },
        winPoint: { active: { $set: form.winPoint.active }, value: { $set: form.winPoint.value } },
        loseBatsu: { active: { $set: false } }
      },
      board: {
        active: { $set: true },
        pointCorrect: { $set: form.otherPointCorrect }
      },
      preset: { $set: form }
    })
    setRule(newRule)
  }

  return (
    <AccordionPreset name={name} label="早押しボード" onSubmit={submit}
                     accordionExpanded={accordionExpanded === name}
                     onAccordionChange={onAccordionChange(name)}>
      <Typography variant="body2">
        ボードクイズです. 早押しで先着した人には特別な正解ポイントがありますが, 特別な誤答ポイントもあります. 先着人数は解答権タブの解答権人数で指定します.
      </Typography>
      <FormGroup row={true} className="mt-5">
        <TextField type="number" variant="standard"
                   label={<>早押し先着<br />正解ポイント</>} className="rights-point-correct tall"
                   inputProps={{ required: true, min: 1 }}
                   value={form.rightsPointCorrect}
                   onChange={change.number(value => ({ rightsPointCorrect: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label={<>その他<br />正解ポイント</>} className="other-point-correct tall ml-10"
                   inputProps={{ required: true, min: 1 }}
                   value={form.otherPointCorrect}
                   onChange={change.number(value => ({ otherPointCorrect: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label={<>早押し先着<br />誤答ポイント</>} className="rights-point-wrong tall ml-10"
                   inputProps={{ required: true, max: 0 }}
                   value={form.rightsPointWrong}
                   onChange={change.number(value => ({ rightsPointWrong: { $set: value } }))} />
      </FormGroup>
      <FormGroup row={true} className="mt-5">
        <Checkbox color="default" className="win-point-active"
                  checked={form.winPoint.active}
                  onChange={change.checked(value => ({ winPoint: { active: { $set: value } } }))} />
        <TextField type="number" variant="standard"
                   label="勝抜ポイント" className="win-point-value"
                   disabled={!form.winPoint.active}
                   inputProps={{ required: true, min: 1 }}
                   value={form.winPoint.value}
                   onChange={change.number(value => ({ winPoint: { value: { $set: value } } }))} />
        <TextField type="number" variant="standard"
                   label="勝抜人数" className="win-players ml-10"
                   inputProps={{ required: true, min: 0 }}
                   value={form.winPlayers}
                   onChange={change.number(value => ({ winPlayers: { $set: value } }))} />
      </FormGroup>
    </AccordionPreset>
  )
}

export default SpeedBoard
